import { images } from './images';
import type { MusicEvent } from '../types/marketplace';

export const events: MusicEvent[] = [
  {
    id: 'e1',
    name: 'Rooftop Soul Sessions',
    organiser: 'Halcyon Rooftop',
    ownedByMe: true,
    date: '2026-10-24',
    startTime: '19:00',
    city: 'Thonglor, Bangkok',
    venue: 'Halcyon Rooftop',
    lat: 13.731,
    lng: 100.583,
    distanceKm: 9,
    theme: 'Golden hour soul',
    type: 'Bar gig',
    genres: ['Soul', 'R&B', 'Jazz'],
    capacity: 180,
    slots: [
      { id: 'e1-s1', kind: 'Solo singer', setLength: 60, budget: 9000 },
      { id: 'e1-s2', kind: 'Duo', setLength: 60, budget: 12000 },
      { id: 'e1-s3', kind: 'Band', setLength: 90, budget: 30000, filledBy: 'p5' },
    ],
    photos: [images.rooftop, images.jazzClub],
    description:
      'Our monthly sunset session above Thonglor. Warm soul and R&B while the city lights come on. In-house PA and sound engineer provided.',
    featured: true,
    applicantIds: ['p2', 'p3', 'p4', 'p6', 'p7', 'p8'],
    status: 'live',
  },
  {
    id: 'e3',
    name: 'Mint & Tan’s Vineyard Wedding',
    organiser: 'Mint & Tan',
    ownedByMe: false,
    date: '2026-11-14',
    startTime: '16:00',
    city: 'Khao Yai, Nakhon Ratchasima',
    venue: 'PB Valley Vineyard',
    lat: 14.517,
    lng: 101.383,
    distanceKm: 165,
    theme: 'Garden party',
    type: 'Wedding',
    genres: ['Soul', 'T-Pop', 'Acoustic'],
    capacity: 120,
    slots: [
      { id: 'e3-s1', kind: 'Solo singer', setLength: 90, budget: 15000 },
      { id: 'e3-s2', kind: 'Band', setLength: 120, budget: 45000 },
    ],
    photos: [images.barn],
    description:
      'A relaxed vineyard wedding in Khao Yai. Acoustic soul and Thai pop for the cocktail hour and first dance, then a party band into the night. Accommodation provided.',
    featured: false,
    applicantIds: ['p1'],
    status: 'live',
  },
  {
    id: 'e4',
    name: 'Chao Phraya Sound Festival',
    organiser: 'Riverside Sound Co.',
    ownedByMe: false,
    date: '2026-10-17',
    startTime: '15:00',
    city: 'Khlong San, Bangkok',
    venue: 'Lhong 1919 Riverside',
    lat: 13.736,
    lng: 100.507,
    distanceKm: 8,
    theme: 'Summer festival',
    type: 'Festival',
    genres: ['Indie', 'T-Pop', 'Folk', 'Soul'],
    capacity: 2500,
    slots: [
      { id: 'e4-s1', kind: 'Band', setLength: 45, budget: 25000 },
      { id: 'e4-s2', kind: 'Duo', setLength: 40, budget: 12000 },
      { id: 'e4-s3', kind: 'Solo singer', setLength: 30, budget: 8000 },
    ],
    photos: [images.festival],
    description:
      'A one-day riverside festival celebrating Bangkok’s local talent. Three stages, family friendly, full production on every stage.',
    featured: true,
    applicantIds: ['p2'],
    status: 'live',
    likesYou: true,
  },
  {
    id: 'e5',
    name: 'Velvet Room Jazz Late',
    organiser: 'The Velvet Room',
    ownedByMe: false,
    date: '2026-10-09',
    startTime: '21:30',
    city: 'Charoen Krung, Bangkok',
    venue: 'The Velvet Room',
    lat: 13.7275,
    lng: 100.5145,
    distanceKm: 8,
    theme: 'Speakeasy',
    type: 'Bar gig',
    genres: ['Jazz', 'Soul'],
    capacity: 70,
    slots: [{ id: 'e5-s1', kind: 'Solo singer', setLength: 120, budget: 7000 }],
    photos: [images.jazzClub],
    description: 'Late-night standards with our house pianist. Two sets, intimate room, attentive crowd.',
    featured: false,
    applicantIds: ['p1', 'p3'],
    status: 'live',
  },
  {
    id: 'e6',
    name: 'Siam Partners Annual Gala',
    organiser: 'Siam Partners',
    ownedByMe: false,
    date: '2026-11-27',
    startTime: '19:00',
    city: 'Pathum Wan, Bangkok',
    venue: 'The Grand Ballroom, Ratchadamri',
    lat: 13.744,
    lng: 100.541,
    distanceKm: 5,
    theme: 'Black tie',
    type: 'Corporate',
    genres: ['Jazz', 'Soul', 'Pop'],
    capacity: 400,
    slots: [
      { id: 'e6-s1', kind: 'Solo singer', setLength: 60, budget: 18000 },
      { id: 'e6-s2', kind: 'Band', setLength: 120, budget: 60000 },
    ],
    photos: [images.gala],
    description:
      'Our yearly client gala. Elegant jazz and soul over dinner, then a band to get everyone dancing. Grand piano available.',
    featured: false,
    applicantIds: [],
    status: 'live',
  },
  {
    id: 'e7',
    name: 'Talat Noi Street Party',
    organiser: 'Talat Noi Collective',
    ownedByMe: false,
    date: '2026-10-11',
    startTime: '16:00',
    city: 'Talat Noi, Bangkok',
    venue: 'Soi Wanit 2',
    lat: 13.7335,
    lng: 100.5125,
    distanceKm: 8,
    theme: 'Retro disco',
    type: 'Private party',
    genres: ['Funk', 'Soul', 'Disco'],
    capacity: 600,
    slots: [
      { id: 'e7-s1', kind: 'Solo singer', setLength: 45, budget: 8000, filledBy: 'p1' },
      { id: 'e7-s2', kind: 'Band', setLength: 60, budget: 25000 },
    ],
    photos: [images.blockParty],
    description: 'Neighbourhood street party among the old shophouses. Funk, soul and disco from late afternoon till late.',
    featured: false,
    applicantIds: ['p1'],
    status: 'live',
  },
  {
    id: 'e9',
    name: 'Hua Hin Beach Weekender',
    organiser: 'Coastline Beach Club',
    ownedByMe: false,
    date: '2026-10-30',
    startTime: '17:30',
    city: 'Hua Hin',
    venue: 'Coastline Beach Club',
    lat: 12.5684,
    lng: 99.9577,
    distanceKm: 190,
    theme: 'Golden hour soul',
    type: 'Bar gig',
    genres: ['Acoustic', 'Soul', 'Folk'],
    capacity: 220,
    slots: [
      { id: 'e9-s1', kind: 'Solo singer', setLength: 90, budget: 12000 },
      { id: 'e9-s2', kind: 'Duo', setLength: 90, budget: 16000 },
    ],
    photos: [images.beach],
    description: 'Sunset sets on the deck. Stripped-back soul and folk while the sun drops into the Gulf. Room and transfer included.',
    featured: false,
    applicantIds: [],
    status: 'live',
    likesYou: true,
  },
  {
    id: 'e2',
    name: 'Halcyon NYE Takeover',
    organiser: 'Halcyon Rooftop',
    ownedByMe: true,
    date: '2026-12-31',
    startTime: '21:00',
    city: 'Thonglor, Bangkok',
    venue: 'Halcyon Rooftop',
    lat: 13.7325,
    lng: 100.5845,
    distanceKm: 9,
    theme: 'Retro disco',
    type: 'Club night',
    genres: ['Funk', 'Disco', 'Pop'],
    capacity: 260,
    slots: [
      { id: 'e2-s1', kind: 'Band', setLength: 120, budget: 50000 },
      { id: 'e2-s2', kind: 'Solo singer', setLength: 45, budget: 10000 },
    ],
    photos: [images.nye, images.rooftop],
    description: 'Countdown to 2027 with a disco band, confetti cannons and the best skyline view in Sukhumvit.',
    featured: false,
    applicantIds: ['p5', 'p6'],
    status: 'live',
  },
  {
    id: 'e10',
    name: 'Songkran Garden Series',
    organiser: 'Halcyon Rooftop',
    ownedByMe: true,
    date: '2027-04-13',
    startTime: '16:00',
    city: 'Thonglor, Bangkok',
    venue: 'Halcyon Rooftop',
    lat: 13.731,
    lng: 100.583,
    distanceKm: 9,
    theme: 'Garden party',
    type: 'Bar gig',
    genres: ['Acoustic', 'T-Pop'],
    capacity: 150,
    slots: [{ id: 'e10-s1', kind: 'Duo', setLength: 90, budget: 12000 }],
    photos: [images.beach],
    description: 'Songkran afternoon acoustic sessions.',
    featured: false,
    applicantIds: [],
    status: 'draft',
  },
  {
    id: 'e11',
    name: 'Rainy Season Finale',
    organiser: 'Halcyon Rooftop',
    ownedByMe: true,
    date: '2026-09-12',
    startTime: '18:00',
    city: 'Thonglor, Bangkok',
    venue: 'Halcyon Rooftop',
    lat: 13.731,
    lng: 100.583,
    distanceKm: 9,
    theme: 'Golden hour soul',
    type: 'Bar gig',
    genres: ['Soul', 'Folk'],
    capacity: 180,
    slots: [{ id: 'e11-s1', kind: 'Duo', setLength: 90, budget: 10000, filledBy: 'p8' }],
    photos: [images.rooftop],
    description: 'End-of-season party.',
    featured: false,
    applicantIds: ['p8'],
    status: 'past',
  },
];
